import { render, staticRenderFns } from "./no-deliverables.vue?vue&type=template&id=8c21216c&scoped=true&"
import script from "./no-deliverables.vue?vue&type=script&lang=js&"
export * from "./no-deliverables.vue?vue&type=script&lang=js&"
import style0 from "./no-deliverables.vue?vue&type=style&index=0&id=8c21216c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c21216c",
  null
  
)

export default component.exports